import React, { Fragment } from 'react'
import classNames from 'classnames'
import { withTranslation } from 'react-i18next'

import ErrorLabel from 'app/components/ErrorLabel/ErrorLabel'
import { promisedGetBase64, promisedImgFromBase64 } from 'helpers'
import ImageCropper from 'app/components/ImageCropper'
import { showError } from 'store/entities/toastr/utils'
import Dropzone from 'react-dropzone'

import UserAvatarPhotoUploader from 'app/domains/common/UserAvatarPhotoUploader'
import Button from 'app/components/ButtonDefault'
import { testImageType, resolveFileExtensions } from 'helpers/patternsRegExp.ts'

import './styles.scss'
const bc = 'profile-form-avatar-input'
const bc1 = 'organizations-details'

/**
 * TODO: combine with app/components/Inputs/ImageInput
 */
class ProfileFormAvatarInput extends React.Component {
  state = {
    file: null,
    mime: null,
    ext: null,
  }

  setTimeout(func) {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    this.timeout = setTimeout(func, 2000)
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  handleDrop = acceptedFiles => {
    const { t } = this.props
    if (acceptedFiles.length) {
      const file = acceptedFiles[0]
      if (!testImageType(file.type)) {
        this.setState({ error: t('wrong-type') })
        showError({ content: t('wrong-type') })
        this.setTimeout(() => {
          this.setState({ error: '' })
        })
      } else {
        promisedGetBase64(file)
          .then(base64String => {
            promisedImgFromBase64(base64String)
              .then(img => {
                if (img.naturalWidth < 400 || img.naturalHeight < 400) {
                  this.setState({ error: t('Image too small') })
                  showError({ content: t('Image too small') })
                  this.setTimeout(() => {
                    this.setState({ error: '' })
                  })
                } else {
                  this.setState({ ext: resolveFileExtensions(file.type) })
                  this.props.showModal(
                    <ImageCropper
                      file={file}
                      title={t('Position and size your avatar')}
                      scale={{ min: 100, max: 200 }}
                      rotate
                      onCancel={this.handleOnCancelImage}
                      onSave={this.handleOnSaveImage}
                      isModal
                    />,
                    { size: 'xs' }
                  )
                }
              })
              .catch(err => {
                console.log(err)
                showError({ content: t('Can not restore from base64') })
              })
          })
          .catch(err => {
            console.log(err)
            showError({ content: t('Can not get base64') })
          })
      }
    }
  }

  handleOnCancelImage = () => {
    this.setState({ file: null })
  }

  handleOnSaveImage = (canvas, canvasScaled) => {
    const { onChange, meta: { form } } = this.props
    const { mime, ext } = this.state
    onChange(canvasScaled, mime, ext, form)
    this.setState({ file: null, mime: null, ext: null })
  }

  render() {
    const { t, input, initials, isDashboardCommitDetails } = this.props
    return (
      <Fragment>
        {isDashboardCommitDetails ? (
          input.value ? (
            <img src={input.value} alt={initials} className={`${bc}__logo-img`} />
          ) : (
            <UserAvatarPhotoUploader onDrop={this.handleDrop} />
          )
        ) : (
          <div className={`${bc1}__top`}>
            <div style={{ borderRadius: '40px' }} className={`${bc1}__logo`}>
              {input.value ? (
                <img src={input.value} alt={initials} className={`${bc1}__logo-img`} />
              ) : (
                <span className="profile-initials">{initials}</span>
              )}
            </div>

            <div className={`${bc1}__wrapper-dropzone`}>
              <div className={`${bc1}__logo-selector`}>
                <div className={`${bc1}__logo-btns`}>
                  <Dropzone
                    className={classNames(`${bc}__button`, {
                      [`${bc}__button--outline`]: !input.value,
                    })}
                    onDrop={this.handleDrop}
                  >
                    {input.value ? t('Replace') : t('Upload Photo')}
                  </Dropzone>
                  {!!input.value && (
                    <Button className={`${bc1}__button`} onClick={() => input.onChange('')}>
                      {t('Remove')}
                    </Button>
                  )}
                </div>
                {this.state.error && <ErrorLabel before="File" htmlFor="nothing" error={this.state.error} />}
              </div>
              <div className={`${bc1}__label-wrapper`}>
                <span className={`${bc1}__label`}>{t('file-format')}</span>
                <span className={`${bc1}__label`}>{t('picture-size')}</span>
              </div>
            </div>
          </div>
        )}
      </Fragment>
    )
  }
}

export default withTranslation()(ProfileFormAvatarInput)
